/**
 * Device type id for tanks.
 *
 * @type {number}
 */
const idDeviceTypeTank = 5;

/**
 * Check if a device is a tank based on its idDeviceType.
 *
 * @param idDeviceType
 * @returns {boolean}
 */
export function isTankDevice(idDeviceType) {
    return idDeviceType === idDeviceTypeTank;
}

/**
 * Device type id for temperature sensors.
 *
 * @type {number}
 */
const idDeviceTypeTempSensor = 17;

/**
 * Check if a device is a temperature sensor based on it's idDeviceType.
 *
 * @param idDeviceType
 * @returns {boolean}
 */
export function isTemperatureSensorDevice(idDeviceType) {
    return idDeviceType === idDeviceTypeTempSensor;
}

/**
 * Get the translation key for a specific temperature sensor type.
 *
 * Generic sensors return null, since we never show that as a device name.
 *
 * @param typeId
 * @returns {string|null}
 */
export function getTemperatureSensorTypeTranslationKey(typeId) {
    const prefix = 'installationoverview';

    switch (typeId) {
        case '0':
            return `${prefix}.temperature_type_battery`;
        case '1':
            return `${prefix}.temperature_type_fridge`;
        case '2':
        default:
            return null;
    }
}

/**
 * Get the translation key for a specific tank type.
 *
 * @param typeId
 * @returns {string|null}
 */
export function getTankTypeTranslationKey(typeId) {
    const prefix = 'installationoverview';

    switch (typeId) {
        case '0':
            return `${prefix}.tank_fluid_type_fuel`;
        case '1':
            return `${prefix}.tank_fluid_type_fresh_water`;
        case '2':
            return `${prefix}.tank_fluid_type_waste_water`;
        case '3':
            return `${prefix}.tank_fluid_type_live_well`;
        case '4':
            return `${prefix}.tank_fluid_type_oil`;
        case '5':
            return `${prefix}.tank_fluid_type_black_water`;
        case '6':
            return `${prefix}.tank_fluid_type_gasoline`;
        case '7':
            return `${prefix}.tank_fluid_type_diesel`;
        case '8':
            return `${prefix}.tank_fluid_type_lpg`;
        case '9':
            return `${prefix}.tank_fluid_type_lng`;
        case '10':
            return `${prefix}.tank_fluid_type_hydraulic_oil`;
        case '11':
            return `${prefix}.tank_fluid_type_raw_water`;
        default:
            return null;
    }
}
